import React from 'react';
import CollapsibleContent from '../CollapsibleContent';
import {UserDetails} from '../../../../models/user/userInfo'
import {EventFullInfo} from '../../../../models/event';
import {EType} from '../../../../models/event/EType';
import {ToggleRSVPtoEvent} from '../../../../models/event/userEventModel'
import {fetchEventAttendees} from '../../../../utils';
import {strArrayToString} from '../../../../utils/str';


interface CollapsibleStandardRSVPProps
{
    startingIsCollapsed: boolean,
    registrantList: UserDetails[],
    eventInfo: EventFullInfo,
    eventType: EType,
    user?: UserDetails,
    authToken ?: string,
    registeredContent ?: any,
    unregisteredContent ?: any,
    onRsvpToggle ?: () => void,
    collapsableTitle ?: string,
    registrationsName ?: string,
    registrationsVerb ?: string
}


interface EventTypeSpecific
{
    collapsableTitle: string,
    registrationsName: string,
    registeredContent: any,
    unregisteredContent: any
}


const CollapsibleStandardRSVP = (props: CollapsibleStandardRSVPProps) =>
{
    let numOfRegistrants: number = props.registrantList.length;

    const [isRegistered, setIsRegistered] = React.useState<boolean>(props.registrantList.filter((usr) => usr.id === props.user?.id).length > 0);
    const [eventRSVPArray, setEventRSVPArray] = React.useState<string[] | undefined>()
    const [eventRSVPString, setEventRSVPString] = React.useState<string>("...");

    const now = new Date();
    const isEventinPast = props.eventInfo.start_DateTime < now;

    const authUser = {
        user: props.user?.id,
        authToken: props.authToken
    }

    const toggleRsvpOnClick = async () => {
        if(await ToggleRSVPtoEvent(props.eventInfo.id, authUser)) {
            setIsRegistered(!isRegistered);
            props.onRsvpToggle && props.onRsvpToggle();
        }

        loadEventRSVPArray();
    }

    const notLoggedIn = (verb: string) => (
        <div>
            <h4>You need to login to {verb}!</h4>
        </div>
    )

    const standardRegisteredContent = (
        <div>
            <h4>You're RSVPed for this event! You may now sign up for and create Sessions!</h4>
            <button onClick={() => toggleRsvpOnClick()}>Un-RSVP from event!</button>
        </div>
    )

    const standardUnegisteredContent = (
        <div>
            <h4>You can RSVP for this event!</h4>
            <button onClick={() => toggleRsvpOnClick()}>RSVP to event!</button>
        </div>
    )









    function loadEventRSVPArray(): void
    {
        if(props.eventInfo)
        {
            fetchEventAttendees(props.eventInfo.id).then((r) =>
            {
                console.log("[CollapsibleStandardRSVP:loadEventRSVPArray:fetchEventAttendees.then] props.eventInfo.id");

                if(r !== undefined)
                {
                        setEventRSVPString(strArrayToString(r, ", ", "@"));
                        numOfRegistrants = r.length;

                        setEventRSVPArray([...r]);

                        //console.log("[CollapsibleStandardRSVP:loadEventRSVPArray:fetchEventAttendees.then] eventRSVPString = " + eventRSVPString);
                        //console.log("[CollapsibleStandardRSVP:loadEventRSVPArray:fetchEventAttendees.then] numOfRegistrants = " + numOfRegistrants.toString());
                }
                else
                {
                    console.log("[CollapsibleStandardRSVP:loadEventRSVPArray:fetchEventAttendees.then] ERROR: r is undefined");
                }
            });
        }
    }





    const specificInfo = props.eventType.name === "Standard" ? {
        collapsableTitle: "RSVP", 
        registrationsName: "RSVPs",
        registrationsVerb: "RSVP",
        registeredContent: standardRegisteredContent,
        unregisteredContent: standardUnegisteredContent
    } : 
    props.eventType.name === "Premium" ? {
        collapsableTitle: props.collapsableTitle ? props.collapsableTitle : "RSVP", 
        registrationsName: props.registrationsName ? props.registrationsName : "RSVPs",
        registrationsVerb: props.registrationsVerb ? props.registrationsVerb : "RSVP",
        registeredContent: props.registeredContent ? props.registeredContent : standardRegisteredContent ,
        unregisteredContent: props.unregisteredContent ? props.unregisteredContent : standardUnegisteredContent
    } : {
        collapsableTitle: "RSVP", 
        registrationsName: "RSVPs",
        registrationsVerb: "RSVP",
        registeredContent: standardRegisteredContent,
        unregisteredContent: standardUnegisteredContent
    }





    React.useLayoutEffect(() =>
    {
        //console.log("[CollapsibleStandardRSVP:props.eventRSVPs useEffect]");
        loadEventRSVPArray();
    }, [props.eventInfo]);





    if(specificInfo === undefined)
    {
        return(<div></div>);
    }

    



    return(
        <div>
            <CollapsibleContent title={specificInfo.collapsableTitle} startingIsCollapsed={props.startingIsCollapsed}>
                {isEventinPast ? 
                <div>
                    <h4>This event has already occured.</h4>
                </div> : 
                <div>
                    <p>{specificInfo.registrationsName} : {numOfRegistrants} / {props.eventInfo.slots}</p>
                    {props.user ? (isRegistered ? specificInfo.registeredContent : specificInfo.unregisteredContent) : notLoggedIn(specificInfo.registrationsVerb)}
                </div>}

                <p>RSVPs: {eventRSVPString}</p>
            </CollapsibleContent>
        </div>
    );

}

export default CollapsibleStandardRSVP;